export let BookingPurpose = /*#__PURE__*/function (BookingPurpose) {
  BookingPurpose["Reschedule"] = "RESCHEDULE";
  BookingPurpose["Booking"] = "BOOKING";
  return BookingPurpose;
}({});
export let BookingCreationEvent = /*#__PURE__*/function (BookingCreationEvent) {
  BookingCreationEvent["Recommendation"] = "RECOMMENDATION";
  BookingCreationEvent["RecommendationGapfiller"] = "RECOMMENDATION_GAPFILLER";
  BookingCreationEvent["CrmRecommendation"] = "CRM_RECOMMENDATION";
  BookingCreationEvent["Upsell"] = "UPSELL";
  BookingCreationEvent["Recall"] = "RECALL";
  return BookingCreationEvent;
}({});
export const vitaminDUpsellInformation = {
  vitaminD: {
    questionContentfulKey: 'upsell.vitamin_d.hint.question',
    answerContentfulKey: 'upsell.vitamin_d.hint.answer_yes',
    answerValue: null
  }
};